import { render } from "./horizontal.vue?vue&type=template&id=2792ce9d"
import script from "./horizontal.vue?vue&type=script&lang=js"
export * from "./horizontal.vue?vue&type=script&lang=js"

import "./horizontal.vue?vue&type=style&index=0&id=2792ce9d&lang=css"

import exportComponent from "/home/aaicom7/repositories/prod/AAI-FMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__